import React from "react";
import { buildDiffGroups } from "./diffGroups";

const styles = {
  added: {
    color: "green",
    backgroundColor: "#b5efdb",
    fontWeight: "500",
  },
  removed: {
    color: "gray",
    backgroundColor: "none",
    textDecoration: "line-through",
  },
};

const DiffMatchPatchViewer = ({ string1 = "", string2 = "", cleanUp = "semantic", editCost = 4, inline = false, showPilcrows = true, diffUnit = "character" }) => {
  const diff = buildDiffGroups(string1, string2, { cleanUp, editCost, diffUnit });
  // console.log("DMP diff groups", diff);
  const mappedNodes = diff.map((group, index) => {
    const key = group[0];
    let value = group[1];
    if (showPilcrows && (key === -1 || key === 1) && !/\S/.test(value)) {
      const linebreaks = value.match(/(\S)*(\r\n|\r|\n)/g);
      // console.log(`contains ${linebreaks.length} new line`, linebreaks);
      if (linebreaks) {
        if (key === -1) value = `\u00b6`.repeat(linebreaks.length);
        if (key === 1) value = `\u00b6\n`.repeat(linebreaks.length);
      }
    }
    let nodeStyles;
    if (key === 1) nodeStyles = styles.added;
    if (key === -1) nodeStyles = styles.removed;
    return inline ? <span key={index} style={nodeStyles}>{value}</span> : <div key={index} style={nodeStyles}>{value}</div>;
  });
  return (
    <span style={{ width: "100%", whiteSpace: "pre-wrap", lineHeight: "1.25em" }}>
      {mappedNodes}
    </span>
  );
};

export default DiffMatchPatchViewer;
